import { Editor } from '@tiptap/react';

import { TextLevelSelect } from './TextLevelSelect';

const textLevels: { value: string; label: string }[] = [
  { value: '1', label: 'title' },
  { value: '2', label: 'headline' },
  { value: '3', label: 'subHeadline' }
];

export type TextLevelOnlySelectProps = {
  editor: Editor | null;
};

export function TextLevelOnlySelect(props: TextLevelOnlySelectProps) {
  const { editor } = props;

  return <TextLevelSelect textLevels={textLevels} editor={editor} />;
}
